import { Injectable } from '@angular/core';
import {ObjectService} from "./abstractions/objects/object.service.abstract";
import {Observable} from "rxjs";
import {HttpResponse} from "@angular/common/http";
import {IFileOptions} from "../../models/file-options.model";

@Injectable({
  providedIn: 'root'
})
export class FilesService extends ObjectService<IFileOptions> {

  protected api = '/files/'; // Base URL for the client API


  /**
   * Uploads a file asynchronously.
   * @param fileId The ID of the file to associate the upload with
   * @param file The file to upload
   * @returns An Observable of the upload operation
   */
  uploadFileAsync(fileId: string, file: File): Observable<string> { // Changed to return Observable<string> for response message
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<string>(`${this.getEndpoint()}${fileId}/upload`, formData, {
      responseType: 'text' as 'json' // To receive plain text response
    });
  }

  /**
   * Publishes a file asynchronously.
   * @param file The file options to publish
   * @returns An Observable of the publish operation
   */
  publishFileAsync(file: IFileOptions): Observable<void> {
    return this.http.post<void>(`${this.getEndpoint()}${file.id}/publish`, file);
  }

  downloadFile(id: string): Observable<HttpResponse<Blob>> {
    return this.http.get(this.getEndpoint() + id + '/download', {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
